module.exports = __webpack_public_path__ + "static/img/logo_01.33dd5101.png";